<template>
  <div class="animated fadeIn form-abm vendedor-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Vendedor">
          <b-form>
            <b-form-group
              label="Código"
              label-for="codigo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigo"
                v-model.trim="$v.codigo.$model" 
                :state="codigoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="codigoFeedback">
                {{ codigoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Celular"
              label-for="celular"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="celular"
                v-model.trim="$v.celular.$model" 
                :state="celularValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="celularFeedback">
                {{ celularInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                v-model.trim="$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              class="tipo-comision"
              label="Tipo de Comisión"
              label-for="tipoComision"
              :label-cols="labelCols"
              horizontal>
              <b-form-radio 
                v-model="tipoComisionPorcentaje" 
                name="opcionTipoComision" 
                :value="Boolean(true)"
                stacked>Porcentaje</b-form-radio>
              <b-form-radio 
                v-model="tipoComisionImporte" 
                name="opcionTipoComision" 
                :value="Boolean(true)"
                stacked>Importe</b-form-radio>
              <b-form-radio 
                v-model="tipoComisionPorcentajeImporte" 
                name="opcionTipoComision" 
                :value="Boolean(true)"
                stacked>Porcentaje + Importe</b-form-radio>
            </b-form-group>

            <b-form-group
              class="tipo-porcentaje"
              label="Tipo de Porcentaje"
              label-for="tipoPorcentaje"
              :label-cols="labelCols"
              horizontal>
              <b-form-radio 
                v-model="tipoPorcentajeFijo" 
                name="opcionTipoPorcentaje" 
                :value="Boolean(true)"
                :disabled="tipoComisionImporte"
                stacked>Porcentaje fijo</b-form-radio>
      
              <b-form-group 
                description="Pje de comisión">
                <b-form-input 
                  id="pjeComision"
                  v-model.trim="$v.pjeComision.$model" 
                  :state="pjeComisionValido"
                  type="number"
                  :readonly="tipoComisionImporte || tipoPjeComision == 2">
                </b-form-input>
                <b-form-invalid-feedback id="pjeComisionFeedback">
                  {{ pjeComisionInvalidoMsj }}
                </b-form-invalid-feedback>
              </b-form-group>
        
              <b-form-radio 
                v-model="tipoPorcentajeFee" 
                name="opcionTipoPorcentaje" 
                :value="Boolean(true)"
                :disabled="tipoComisionImporte"
                stacked>Porcentaje del Fee</b-form-radio>
              
              <b-form-group 
                description="Pje del Fee como Comisión">
                <b-form-input 
                  id="pjeFeeComision"
                  v-model.trim="$v.pjeFeeComision.$model" 
                  :state="pjeFeeComisionValido"
                  type="number"
                  :readonly="tipoComisionImporte || tipoPjeComision == 1">
                </b-form-input>
                <b-form-invalid-feedback id="pjeFeeComisionFeedback">
                  {{ pjeFeeComisionInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-form-group>
            </b-form-group>
          
            <b-form-group
              label="Importe"
              label-for="importeComision"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="importeComision"
                v-model.trim="$v.importeComision.$model" 
                :state="importeComisionValido"
                type="number"
                :readonly="tipoComisionPorcentaje">
              </b-form-input>
              <b-form-invalid-feedback id="importeComisionFeedback">
                {{ importeComisionInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="5"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card>
          <template slot="header">
            Clientes
            <i class="fa fa-plus add-proveedor"
              @click.prevent="agregarCliente">
              <span>Agregar Cliente</span>
            </i>
          </template>  

          <b-table 
              class="registro clientes"
              responsive="sm" 
              :items="clientes" 
              :fields="clientesFields">
            <template v-slot:cell(pjeComision)="data">
              <template v-if="(data.item.tipoComision == 1 || data.item.tipoComision == 3) && data.item.tipoPjeComision == 1">
                {{ data.item.pjeComision | numero(2) }}
              </template>
              <template v-else>
                --.--
              </template>
            </template>
            <template v-slot:cell(pjeFeeComision)="data">
              <template v-if="(data.item.tipoComision == 1 || data.item.tipoComision == 3) && data.item.tipoPjeComision == 2">
                {{ data.item.pjeFeeComision | numero(2) }}
              </template>
              <template v-else>
                --.--
              </template>
            </template>
            <template v-slot:cell(importeComision)="data">
              <template v-if="data.item.tipoComision == 2 || data.item.tipoComision == 3">
                {{ data.item.importeComision | moneda }}
              </template>
              <template v-else>
                --.--
              </template>
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editarCliente(data.item)">
                  <i class="fa fa-edit"></i>Editar Cliente</b-dropdown-item>
                <b-dropdown-item @click.stop="removeCliente(data.item)">
                  <i class="fa fa-remove"></i>Borrar Cliente</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card>
          <template slot="header">
            Proveedores
            <i class="fa fa-plus add-proveedor"
              @click.prevent="seleccionarProveedor">
              <span>Agregar Proveedor</span>
            </i>
          </template>  

          <b-table 
              class="registro proveedores"
              responsive="sm" 
              :items="proveedores" 
              :fields="proveedoresFields">
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="removeProveedor(data.item)">
                  <i class="fa fa-remove"></i>Borrar Proveedor</b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="clienteModal" 
        title="Parametros del Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cliente
        :vendedorCliente="vendedorCliente"
        @actualizarCliente="actualizarCliente"
        @cancelar="cancelarActualizacionCliente">
      </app-cliente>  
    </b-modal>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue'
import Cliente from './Cliente.vue'
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength, email, decimal, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'vendedor/getField',
  mutationType: 'vendedor/updateField',
});

export default {
  name: 'VendedorABM',
  components: {
    appCliente: Cliente,
    appSearchProveedor: SearchProveedor,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal,
    confirmModal 
  ],
  data () {
    return {
      noValidar: true,
      codigoValido: null,
      codigoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      celularValido: null,
      celularInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',
      pjeComisionValido: null,
      pjeComisionInvalidoMsj: '',
      pjeFeeComisionValido: null,
      pjeFeeComisionInvalidoMsj: '',
      importeComisionValido: null,
      importeComisionInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      clientesFields: [
        {
          key: 'clienteNombre',
          label: 'Cliente'
        },
        {
          key: 'clienteContactoNombre',
          label: 'Contacto'
        },
        {
          key: 'pjeComision',
          class: "text-right"
        },
        {
          key: 'pjeFeeComision',
          label: 'Pje. Fee Comision',
          class: "text-right"
        },
        {
          key: 'importeComision',
          label: 'Importe Comision',
          class: "text-right"
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],
      proveedoresFields: [
        { 
          key: 'nombre',
          label: 'Proveedor'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      labelCols: 2,
      vendedorCliente: null
    }
  },
  computed: {
    ...mapFields([
      'id',
      'codigo',
      'nombre',
      'celular',
      'email',
      'tipoComision',
      'tipoPjeComision',
      'pjeComision',
      'pjeFeeComision',
      'importeComision',
      'observaciones',
      'inactivo',
      'clientes',
      'proveedores',
    ]),
    tipoComisionPorcentaje: {
      get() {
        return this.tipoComision == 1;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 1;
        }
      }
    },
    tipoComisionImporte: {
      get() {
        return this.tipoComision == 2;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 2;
        }
      }
    },
    tipoComisionPorcentajeImporte: {
      get() {
        return this.tipoComision == 3;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 3;
        }
      }
    },
    tipoPorcentajeFijo: {
      get() {
        return this.tipoPjeComision == 1;
      },
      set(newVal) {
        if (newVal) {
          this.tipoPjeComision = 1;
        }
      }
    },
    tipoPorcentajeFee: {
      get() {
        return this.tipoPjeComision == 2;
      },
      set(newVal) {
        if (newVal) {
          this.tipoPjeComision = 2;
        }
      }
    },
  },  
  created() {
    let vendedorId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        vendedorId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('vendedor/inicializar', vendedorId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'codigo' || validarTodos) {
        if (this.$v.codigo.$error) {
          this.codigoValido = false;
          if (!this.$v.codigo.required) {
            this.codigoInvalidoMsj= 'Debe ingresar el código del vendedor.';
          } else if (!this.$v.codigo.maxLength) {
            this.codigoInvalidoMsj = 'El código solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.codigoValido = null;
          this.codigoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del vendedor.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 75 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
        
      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false;
          if (!this.$v.celular.maxLength) {
            this.celularInvalidoMsj = 'El número de celular solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.celularValido = null;
          this.celularInvalidoMsj = '';
        }
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false
          if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida.';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }

      if (campo == 'pjeComision' || validarTodos) {
        if (this.$v.pjeComision.$error) {
          this.pjeComisionValido = false;
          if (!this.$v.pjeComision.decimal) {
            this.pjeComisionInvalidoMsj = 'El pje de comisión debe ser un valor numérico';
          } else {
            if (!this.$v.pjeComision.maxValue || !this.$v.pjeComision.minValue) {
              this.pjeComisionInvalidoMsj = 'El pje de comisión ingresado no es válido';
            }      
          }     
        } else {
          this.pjeComisionValido = null;
          this.pjeComisionInvalidoMsj = '';
        }
      }

      if (campo == 'pjeFeeComision' || validarTodos) {
        if (this.$v.pjeFeeComision.$error) {
          this.pjeFeeComisionValido = false;
          if (!this.$v.pjeFeeComision.decimal) {
            this.pjeFeeComisionInvalidoMsj = 'El pje de comisión debe ser un valor numérico';
          } else {
            if (!this.$v.pjeFeeComision.maxValue || !this.$v.pjeFeeComision.minValue) {
              this.pjeFeeComisionInvalidoMsj = 'El pje de comisión ingresado no es válido';
            }      
          }     
        } else {
          this.pjeFeeComisionValido = null;
          this.pjeFeeComisionInvalidoMsj = '';
        }
      }

      if (campo == 'importeComision' || validarTodos) {
        if (this.$v.importeComision.$error) {
          this.importeComisionValido = false;
          if (!this.$v.importeComision.decimal) {
            this.importeComisionInvalidoMsj = 'El importe de comisión debe ser un valor numérico';
          } else {
            if (!this.$v.importeComision.minValue) {
              this.importeComisionInvalidoMsj = 'El importe de comisión ingresado no es válido';
            }      
          }     
        } else {
          this.importeComisionValido = null;
          this.importeComisionInvalidoMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres.';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('vendedor/save')
            .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "Vendedores" });
    },
    removeProveedor(item) {
      this.showModalConfirm('¿Desea borrar la relación con el proveedor seleccionado?', 
        this.remove.bind(this, item.id), 'Si', null, 'No')
    },
    remove(proveedorId) {
        this.$store.dispatch('vendedor/removeProveedor', proveedorId)
          .catch(error => this.showErrorMsj(error));
    },
    seleccionarProveedor() {
      this.$refs.searchProveedorModal.show();
    },
    proveedorSeleccionado(proveedor) {
      this.$refs.searchProveedorModal.hide();
      this.$store.dispatch('vendedor/addProveedor', proveedor)
        .catch(error => this.showErrorMsj(error))
    },

    agregarCliente() {
      this.vendedorCliente = null;
      this.$refs.clienteModal.show();
    },
    editarCliente(item) {
      this.vendedorCliente = item;
      this.$refs.clienteModal.show();
    },
    removeCliente(item) {
      this.showModalConfirm('¿Desea borrar la condición del cliente seleccionado?', 
        this.removeClienteSeleccionado.bind(this, item), 'Si', null, 'No')
    },
    removeClienteSeleccionado(params) {
      this.$store.dispatch('vendedor/removeCliente', params)
        .catch(error => this.showErrorMsj(error))
    },
    actualizarCliente(params) {
      this.$refs.clienteModal.hide();

      this.$store.dispatch('vendedor/upsertCliente', params)
        .catch(error => this.showErrorMsj(error))

      // this.$store.dispatch('vendedor/addCliente', params)
      //   .catch(error => this.showErrorMsj(error))

    },
    cancelarActualizacionCliente() {
      this.$refs.clienteModal.hide();
    }
  },
  watch: {
  },
  validations: {
    codigo: {
      required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(75)
    },
    celular: {
      maxLength: maxLength(50)
    },
    email: {
      email,
      maxLength: maxLength(150)
    },
    pjeComision: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    pjeFeeComision: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    importeComision: {
      decimal,
      minValue: minValue(0)
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
  /* 
  .vendedor-abm .custom-radio {
    margin-left: 15px;
  }
  .vendedor-abm .custom-radio-value-group {
    margin-top: 15px;
  }
  .vendedor-abm .custom-radio-value-group label.col-form-label {
    padding-left: 45px;
  } 
  */

  .vendedor-abm .custom-radio {
    margin-bottom: 10px;
  }
  .vendedor-abm .form-group.tipo-comision .col,
  .vendedor-abm .form-group.tipo-porcentaje .col {
    padding-top: 20px;
  }


  .vendedor-abm .card-header i.add-proveedor {
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    cursor: pointer;
    margin-left: 12px;
    top: 2px; 
  }
  .vendedor-abm .card-header i.add-proveedor:hover {
    color: #20a8d8;
  }
  .vendedor-abm .card-header span {
    font-size: 11px;
    font-weight: 600;
    font-style: italic;
    top: -2px;
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    margin-left: 5px;
  }
  .vendedor-abm .card-header i.add-proveedor:hover span{
    color: #20a8d8;
  }

  .vendedor-abm .registro.clientes table td[aria-colindex="1"] {
    width: calc(36% - 60px);
  }
  .vendedor-abm .registro.clientes table td[aria-colindex="2"] {
    width: 30%;
  }
  .vendedor-abm .registro.clientes table td[aria-colindex="3"] {
    width: 12%;
  }
  .vendedor-abm .registro.clientes table td[aria-colindex="4"] {
    width: 10%;
  }
  .vendedor-abm .registro.clientes table td[aria-colindex="5"] {
    width: 12%;
  }
  .vendedor-abm .registro.clientes table td[aria-colindex="6"] {
    width: 60px;
  }

  .vendedor-abm .registro.proveedores table td[aria-colindex="1"] {
    width: calc(100% - 60px);
  }
  .vendedor-abm .registro.proveedores table td[aria-colindex="2"] {
    width: 60px;
  }
</style>
